import * as React from "react";
import * as ReactDOM from "react-dom";
import { Navigation, NavigationItem, NavigationSeparator } from "../../components/navigation";
import { IUser } from "../../models/get";
import { getCurrentUserAsync } from "../../globals";

interface IProperties
{
    selected: "profile" |
    "security" |
    "notifications"
    
}

interface IState
{
    user?: IUser
}

export default class ProfileNav extends React.Component<IProperties, IState>
{
    /**
     * Erstellt eine neue Instanz der Klasse @see SettingsNav.
     * @param props Alle gesetzten Eigenschaften.
     */
    constructor(props: IProperties)
    {
        super(props);
        this.state = {};
    }

    async componentDidMount()
    {
        const user: IUser = await getCurrentUserAsync();
        this.setState({
            user: user
        });
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { selected } = this.props;
        const { user } = this.state;

        if (user == null)
            return null;

        return (
            <Navigation direction="vertical">
                <NavigationItem
                    text="Profil"
                    isSelected={selected === "profile"}
                    linkTo={selected === "profile" ? null : "/user/profile/general"}
                />
                <NavigationItem
                    text="Sicherheit"
                    isSelected={selected === "security"}
                    linkTo={selected === "security" ? null : "/user/profile/security"}
                />
                <NavigationSeparator />
                <NavigationItem
                    text="Benachrichtigungen"
                    isSelected={selected === "notifications"}
                    linkTo={selected === "notifications" ? null : "/user/profile/notifications"}
                />
            </Navigation>
        );
    }
}